import httpClient from './httpClient'

const AgencyMarginRequestApi = {
  async search({ query, pageSize, pageNo }) {
    const { systemOwnerId, keyword, requestStatus } = query
    try {
      const res = await httpClient.post('/request/agency_margin/search', {
        query: { systemOwnerId, keyword, requestStatus },
        pageSize,
        pageNo,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw new Error('Error: POST /request/agency_margin/search')
    }
  },
  async create({
    agencyId,
    name,
    agencyMarginId = null,
    startDate,
    endDate,
    marginValue,
    note,
  }) {
    try {
      const res = await httpClient.post(`/request/agency_margin`, {
        agencyId,
        name,
        agencyMarginId,
        startDate,
        endDate,
        marginValue,
        note,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw new Error('Error: POST /request/agency_margin')
    }
  },
  /**
   * 申請取り消し
   */
  async delete(id) {
    try {
      const res = await httpClient.delete(`/request/agency_margin/${id}`)
      return res.data
    } catch (e) {
      console.error(e)
      throw new Error(`Error: DELETE /request/agency_margin/${id}`)
    }
  },
  /**
   * 承認/却下
   */
  async update(id, { name, requestStatus, reason, note }) {
    try {
      const res = await httpClient.put(`/request/agency_margin/${id}`, {
        name,
        requestStatus,
        reason,
        note,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw new Error(`Error: PUT /request/agency_margin/${id}`)
    }
  },
}

export default AgencyMarginRequestApi
